import { useTheme } from '@hover/blueprint';

/**
 * Depth to use for any `position: sticky` elements such as the header/navbar
 * and filter menus. This one less than the modal overlay, so that the sticky
 * elements are always under modals, drawers etc. but over everything else.
 *
 * @returns `z-index` value
 */
const useStickyDepth = () => useTheme().zIndices.overlay - 1;

export { useStickyDepth };
